var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Close Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.5 2.54687H5.79297C5.91813 2.54647 6.04259 2.57119 6.1582 2.61914C6.24474 2.65505 6.32546 2.70328 6.39746 2.76269L6.4668 2.82617L8.1875 4.54687H13.5C13.7528 4.54687 13.9951 4.64742 14.1738 4.82617C14.3526 5.00491 14.4531 5.24721 14.4531 5.49999V12.5557C14.4528 12.7936 14.3577 13.0212 14.1895 13.1894C14.0212 13.3577 13.7936 13.4528 13.5557 13.4531H2.46094C2.21865 13.4527 1.98676 13.3559 1.81543 13.1846C1.6441 13.0132 1.54729 12.7814 1.54688 12.5391V3.49999C1.54688 3.24721 1.64743 3.00491 1.82617 2.82617C2.00492 2.64742 2.24722 2.54687 2.5 2.54687ZM2.45312 12.5469H13.5469V5.45312H2.45312V12.5469ZM2.45312 4.54687H6.90625L5.8125 3.45312H2.45312V4.54687Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.09375
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifOpen);
export default __webpack_public_path__ + "static/media/notif-open.af9490fac28a9f775c2ef56208752cee.svg";
export { ForwardRef as ReactComponent };